import { CloseOutlined, TagOutlined } from '@ant-design/icons';
import { App, Button, Input, Space } from 'antd';
import { useEffect, useState } from 'react';
import { ICheckoutItem } from '../../../interfaces/ICheckout';
import { checkoutService } from '../../../services/CheckoutService';
import { useForm } from '../context';

const Coupon = () => {
  const { message } = App.useApp();
  const { appliedCoupon, setAppliedCoupon, items, addItems, checkout, firstItem } = useForm();
  const [showInput, setShowInput] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [oldItemsLength, setOldItemsLength] = useState(items.length);

  const handleToggleInput = () => {
    setShowInput(!showInput);
    if (showInput) {
      setCouponCode('');
    }
  };

  const handleApplyCoupon = async (items: ICheckoutItem[], withMessage = true) => {
    if (!couponCode.trim()) {
      message.warning('Digite um código de cupom válido');
      return;
    }

    setLoading(true);
    try {
      const response = await checkoutService.applyCoupon(checkout?.teamId, items, couponCode);
      setAppliedCoupon(response.coupon);
      addItems(response.items);

      withMessage && message.success('Cupom aplicado');
      setShowInput(false);
    } catch (error) {
      message.error('Cupom inválido ou expirado');
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveCoupon = () => {
    setAppliedCoupon(undefined);
    addItems(items.map((item) => ({ ...item, couponItem: undefined })));
    setCouponCode('');
    setShowInput(false);
    message.success('Cupom removido');
  };

  useEffect(() => {
    if (appliedCoupon && items.length !== oldItemsLength) {
      setOldItemsLength(items.length);
      handleApplyCoupon(items, false);
    }
  }, [items]);

  if (!checkout?.hasCoupon || firstItem?.config?.isOpenValue) {
    return null;
  }

  if (appliedCoupon) {
    return (
      <div className="flex items-center mt-2 gap-1">
        <div className="text-sm font-medium text-green-700">
          <TagOutlined className="mr-2" />
          Cupom <strong>{appliedCoupon?.code?.substring(0, 10)}</strong> aplicado
        </div>

        <Button danger onClick={handleRemoveCoupon} size="small" type="text" className='text-sm p-0 w-7 h-7'>
          <CloseOutlined />
        </Button>
      </div>
    );
  }

  return (
    <div className="mt-2">
      {!showInput && (
        <Button color="default" variant="filled" onClick={handleToggleInput} size="small" className="text-sm">
          <TagOutlined />
          Cupom de desconto?
        </Button>
      )}

      {showInput && (
        <div className="space-y-1">
          <div className="flex gap-1">
            <Space.Compact>
              <Input
                placeholder="Código do cupom"
                value={couponCode}
                size="small"
                onChange={(e) => setCouponCode(e.target.value.toUpperCase().replace(/\s/g, ''))}
                onPressEnter={() => handleApplyCoupon(items)}
                className="flex-1 max-w-[150px] text-sm"
              />

              <Button className='text-sm' size='small' type="primary" onClick={() => handleApplyCoupon(items)} loading={loading}>
                Aplicar
              </Button>
            </Space.Compact>

            <Button danger onClick={handleToggleInput} size="small" type="text" className='p-0 w-9'>
              <CloseOutlined />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Coupon;
